import { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Button from '../../../../common/Button'
import InputText from '../../../../common/InputText'
import {
  getRequest,
  postRequest,
  putRequest,
} from '../../../../../services/base'
import { NavContext } from '../../../../../context/global_context'
import Modal, { ModalBody, ModalHeader } from '../../../../common/Modal'
import SelectInput from '../../../../common/SelectInput'

const DEFAULT_FORM_VALUES = {
  name: '',
  system: '',
  system_data: {},
  sub_system_id: '',
}

const SubSystemEditCreateForm = (props) => {
  const [state, dispatch] = useContext(NavContext)

  const [subSystemDetails, setSubSystemDetails] = useState(DEFAULT_FORM_VALUES)
  const [subSystemListData, setSubSystemListData] = useState([])

  useEffect(() => {
    if (props?.selectedSubSystem?.id) {
      setSubSystemDetails(props?.selectedSubSystem)
    } else {
      setSubSystemDetails(DEFAULT_FORM_VALUES)
    }
    getSystemList('')
  }, [props?.selectedSubSystem?.id])

  const getSystemList = async (searchValue = '') => {
    let response = await getRequest(`/api/system/?search=${searchValue}`)
    setSubSystemListData(response.results)
  }

  const saveSystemDetails = async (e) => {
    const form = e.target
    const formData = new FormData(form)
    let res = null
    if (props?.selectedSubSystem?.id) {
      res = await putRequest(
        `/api/sub_system/${props?.selectedSubSystem?.id}/`,
        formData
      )
    } else {
      res = await postRequest(`/api/sub_system/`, formData)
    }
    if (res?.status) {
      setSubSystemDetails({})
      props.onSave()
    } else {
      let msg = ''
      Object.keys(res).map((obj) => {
        if (msg) {
          msg += `, ${res[obj]}`
        } else {
          msg = `${res[obj]}`
        }
      })

      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: msg,
        },
      })
    }
  }

  return (
    <Modal
      onClose={() => {
        setSubSystemDetails({})
        props.setShowModal(false)
        props.onClose()
      }}
      show={props.showModal}
    >
      <ModalHeader className={'text-white'}>
        {props.selectedSubSystem?.id
          ? 'Update Existing Sub System'
          : 'Create New Sub System'}
      </ModalHeader>
      <ModalBody>
        <div className="">
          <form
            onSubmit={(e) => {
              e.preventDefault()
              saveSystemDetails(e)
            }}
          >
            <input
              type="hidden"
              value={props?.selectedSubSystem?.id ? false : true}
              name="is_create"
            />
            {props?.selectedSubSystem?.id && (
              <input
                type="hidden"
                name="id"
                value={props?.selectedSubSystem?.id}
              />
            )}
            <div className="flex">
              <div className="w-1/2">
                <InputText
                  name="sub_system_id"
                  type="text"
                  label="Sub System Id"
                  value={subSystemDetails.sub_system_id}
                />
              </div>
              <div className="w-1/2">
                <InputText
                  name="name"
                  type="text"
                  label="Name"
                  value={subSystemDetails.name}
                />
              </div>
            </div>
            <div className="flex">
              <div className="w-1/2">
                <SelectInput
                  value={subSystemDetails?.system_data}
                  onChange={(value) => {
                    setSubSystemDetails({
                      ...subSystemDetails,
                      system: value,
                      system_data: value,
                    })
                  }}
                  label="System"
                  name="system"
                  isRequired={false}
                  options={subSystemListData}
                  optionLabel={'name'}
                  optionValue={'id'}
                  onInputChange={(value) => {
                    getSystemList(value)
                  }}
                />
              </div>
            </div>

            <div className="flex justify-end">
              <Button
                type="submit"
                className={`cursor-pointer btn my-4 justify-end`}
                onClick={(e) => {}}
                value={'text'}
                text={
                  props.selectedSubSystem?.id
                    ? 'Save Sub System'
                    : 'Create New Sub System'
                }
              />
            </div>
          </form>
        </div>
      </ModalBody>
    </Modal>
  )
}

SubSystemEditCreateForm.propTypes = {
  selectedSubSystem: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  setShowModal: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
}

export default SubSystemEditCreateForm
